import { Select } from "@primer/react"
import { ITienDoNhapDiemLopHanhChinhRequest } from "../../model/request/tong-hop/ITienDoNhapDiemLopHanhChinhRequest"
import { apiClient } from "../apiClient"
import { ITienDoNhapDiemLopTinChiRequest } from "../../model/request/tong-hop/ITienDoNhapDiemLopTinChiRequest"

const TIEN_DO_NHAP_DIEM_API = {
    LOP_HANH_CHINH_THANH_PHAN: 'tien-do-nhap-diem/lop-hanh-chinh/thanh-phan',
    LOP_TIN_CHI_THANH_PHAN: 'tien-do-nhap-diem/lop-tin-chi/thanh-phan',
    LOP_HANH_CHINH_THI: 'tien-do-nhap-diem/lop-hanh-chinh/thi',
    LOP_TIN_CHI_THI: 'tien-do-nhap-diem/lop-tin-chi/thi',
}

export const tienDoNhapDiemApi = {
    SelectLopHanhChinhThanhPhan: (request: ITienDoNhapDiemLopHanhChinhRequest) => apiClient.post(`${TIEN_DO_NHAP_DIEM_API.LOP_HANH_CHINH_THANH_PHAN}`, request),
    SelectLopTinChiThanhPhan: (request: ITienDoNhapDiemLopTinChiRequest) => apiClient.post(`${TIEN_DO_NHAP_DIEM_API.LOP_TIN_CHI_THANH_PHAN}`, request),
    SelectLopHanhChinhThi: (request: ITienDoNhapDiemLopHanhChinhRequest) => apiClient.post(`${TIEN_DO_NHAP_DIEM_API.LOP_HANH_CHINH_THI}`, request),
    SelectLopTinChiThi: (request: ITienDoNhapDiemLopTinChiRequest) => apiClient.post(`${TIEN_DO_NHAP_DIEM_API.LOP_TIN_CHI_THI}`, request),
    }